import React from "react";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import "../css/contactus.scss";

const toTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

function Contact() {
  return (
    <div className="contact">
      <Header />

      <main
        className="contact__main"
        id="MainContent"
        role="main"
        tabIndex={-1}
      >
        <header className="contact__hero" aria-labelledby="contact-heading">
          <div className="contact__hero-inner">
            <Link
              className="contact__back"
              to="/shipping"
              onClick={toTop}
              aria-label="Back to Useful Info"
            >
              <svg
                className="contact__back-icon"
                xmlns="http://www.w3.org/2000/svg"
                width={6}
                height={11}
                viewBox="0 0 6 11"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M0.308181 5.59453C0.313452 5.77902 0.381976 5.9477 0.529569 6.08475L4.63054 10.0908C4.7465 10.2068 4.89409 10.2701 5.06804 10.2701C5.41594 10.2701 5.69531 9.99595 5.69531 9.64806C5.69531 9.47938 5.62679 9.31597 5.50555 9.19474L1.81046 5.5998L5.50555 1.99432C5.62152 1.87309 5.69531 1.71495 5.69531 1.541C5.69531 1.19311 5.41594 0.919006 5.06804 0.919006C4.8941 0.919006 4.7465 0.98226 4.63054 1.09823L0.529569 5.10958C0.381976 5.2519 0.308181 5.41004 0.308181 5.59453Z"
                  fill="currentColor"
                />
              </svg>
              <span>Useful Info</span>
            </Link>
            <h1 id="contact-heading" className="contact__title">
              Contact Us
            </h1>
          </div>
        </header>

        <section
          className="contact__body"
          aria-labelledby="contact-intro-heading"
        >
          <div className="contact__inner">
            <h2 id="contact-intro-heading" className="contact__subhead">
              Want to Say Hey?
            </h2>
            <p className="contact__lead">Here&apos;s how to get in touch.</p>
            <p className="contact__hours">
              Answering in real time 9am–5pm PT, Monday through Friday.
            </p>

            <div className="contact__grid">
              <article className="contact__card">
                <div className="contact__icon-wrap" aria-hidden="true">
                  <svg
                    className="contact__icon"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="24"
                      cy="24"
                      r="22.5"
                      stroke="currentColor"
                      strokeWidth="1"
                    />
                    <rect
                      x="12"
                      y="16"
                      width="24"
                      height="16"
                      rx="1.5"
                      stroke="currentColor"
                      strokeWidth="1"
                    />
                    <path
                      d="M12 19L24 27L36 19"
                      stroke="currentColor"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <h3 className="contact__card-title">Email Us</h3>
                <p className="contact__detail">
                  <a
                    className="contact__detail-text"
                    href="mailto:buyer@mvandora.store"
                  >
                    buyer@mvandora.store
                  </a>
                </p>
                <p className="contact__desc">
                  This is the best and fastest way to reach us. Just send us a
                  note and we&apos;ll get back to you within 24 hours.
                </p>
              </article>

              <article className="contact__card">
                <div className="contact__icon-wrap" aria-hidden="true">
                  <svg
                    className="contact__icon"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="24"
                      cy="24"
                      r="22.5"
                      stroke="currentColor"
                      strokeWidth="1"
                    />
                    <path
                      d="M18.5 12.5h2.2c.6 0 1.1.4 1.2 1l1.1 5.2c.1.5-.1 1-.5 1.3l-1.4 1.4c1.8 3.5 4.7 6.4 8.2 8.2l1.4-1.4c.3-.4.8-.6 1.3-.5l5.2 1.1c.6.1 1 .6 1 1.2v2.2c0 1.1-.8 2-1.9 2.1-8.5.9-16.4-6.3-17.3-14.8-.1-1.1.9-2 2-2z"
                      stroke="currentColor"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <h3 className="contact__card-title">Company</h3>
                <p className="contact__detail">
                  <span className="contact__detail-text">ENZIROT LIMITED</span>
                </p>
                <p className="contact__detail">
                  <a
                    className="contact__detail-text"
                    href="https://mvandora.store"
                    target="_blank"
                    rel="noreferrer"
                  >
                    mvandora.store
                  </a>
                </p>
                <p className="contact__desc">
                  Our customer service team can assist with products, orders,
                  delivery, and returns.
                </p>
              </article>

              <article className="contact__card">
                <div className="contact__icon-wrap" aria-hidden="true">
                  <svg
                    className="contact__icon"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="24"
                      cy="24"
                      r="22.5"
                      stroke="currentColor"
                      strokeWidth="1"
                    />
                    <path
                      d="M11.5 24.5v-5c0-1.4 1.1-2.5 2.5-2.5h8c1.4 0 2.5 1.1 2.5 2.5v3c0 1.4-1.1 2.5-2.5 2.5h-4.5l-2.5 3v-3h-.5c-1.4 0-2.5-1.1-2.5-2.5z"
                      stroke="currentColor"
                      strokeWidth="1"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M23.5 17.5v-3c0-1.4 1.1-2.5 2.5-2.5h9c1.4 0 2.5 1.1 2.5 2.5v5.5c0 1.4-1.1 2.5-2.5 2.5h-1l2 2.5v-2.5h-5c-1.4 0-2.5-1.1-2.5-2.5v-2"
                      stroke="currentColor"
                      strokeWidth="1"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <h3 className="contact__card-title">Postal Address</h3>
                <p className="contact__desc">
                  291597 OFFICE SUITE 29A, 3/F 23 WHARF STREET, LONDON,
                  ENGLAND SE8 3GG
                </p>
              </article>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Contact;
